import apiClient from "./apiClient";

export const fetchStrategyNotices = (params = {}) => {
    return apiClient.get("/api/exchange-noti/notices/strategy", { params });
};

export const fetchNotiHealth = () => {
    return apiClient.get("/api/exchange-noti/health");
};

// 지갑 상태 현재 스냅샷 조회
export const fetchWalletStatus = (params = {}) => {
    return apiClient.get("/api/exchange-noti/wallet-status", { params });
};

// 지갑 상태 변경 이력 조회
export const fetchWalletStatusChanges = (params = {}) => {
    return apiClient.get("/api/exchange-noti/wallet-status/changes", { params });
};

// 지갑 상태 통계 요약 조회 (per BAPI-04)
export const fetchWalletStatusStats = () => {
    return apiClient.get("/api/exchange-noti/wallet-status/stats");
};

// 거래지원 종료 공지 조회
export const fetchDelistingNotices = (params = {}) => {
    return apiClient.get("/api/exchange-noti/delisting-notices", { params });
};

// 신규 상장 공지 조회 (EN 서버 프록시)
export const fetchNewListingNotices = (params = {}) => {
    return apiClient.get("/api/exchange-noti/new-listing-notices", { params });
};
